import type { PoiDto, PoiCreateDto, PoiUpdateDto } from '@camper-diary/shared';
import { api } from './client';

export type Poi = PoiDto;

export function listPois() {
  return api<Poi[]>('/pois');
}

export function createPoi(input: PoiCreateDto) {
  return api<Poi>('/pois', { method: 'POST', body: input });
}

export function updatePoi(id: string, input: PoiUpdateDto) {
  return api<Poi>(`/pois/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: input,
  });
}

export function deletePoi(id: string) {
  return api<null>(`/pois/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
